import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React from 'react';
import { DEFAULT_SLIDE_DIRECTION, DEFAULT_SLIDE_DISTANCE, DEFAULT_SLIDE_FADE, DIRECTIONS } from './SlideReveal.constants';
import { getSlideKeyFrames } from './SlideReveal.utils';
import { ChildrenPropType } from '../../../../../../services/proptypes';
import { classNames } from '../../../../../../utils/classname';
import { DEFAULT_REVEAL_PROPS } from '../../../../reveal.constants';
import { BaseRevealOptionsPropTypes } from '../../../../types/reveal.types';
import Reveal from '../../Reveal';
import './SlideReveal.less';
var defaultProps = _objectSpread(_objectSpread({}, DEFAULT_REVEAL_PROPS), {}, {
  className: '',
  children: null,
  content: null,
  direction: DEFAULT_SLIDE_DIRECTION,
  distance: DEFAULT_SLIDE_DISTANCE,
  fade: DEFAULT_SLIDE_FADE,
  firstAnimation: {}
});
export default function SlideReveal(_ref) {
  var _classNames;
  var className = _ref.className,
    children = _ref.children,
    content = _ref.content,
    duration = _ref.duration,
    delay = _ref.delay,
    disableAnimation = _ref.disableAnimation,
    disableAnimationOnMobile = _ref.disableAnimationOnMobile,
    cascade = _ref.cascade,
    cascadeFactor = _ref.cascadeFactor,
    triggerOnce = _ref.triggerOnce,
    onVisibilityChange = _ref.onVisibilityChange,
    direction = _ref.direction,
    distance = _ref.distance,
    fade = _ref.fade,
    fraction = _ref.fraction,
    firstAnimation = _ref.firstAnimation,
    noContainer = _ref.noContainer;
  var finalClassName = classNames((_classNames = {
    slide: true
  }, _defineProperty(_classNames, className, className), _defineProperty(_classNames, "fade", fade), _classNames));
  var defaultKeyFrameOptions = {
    direction: direction,
    distance: distance,
    fade: fade
  };
  var slideKeyFrames = getSlideKeyFrames({
    direction: direction,
    distance: distance,
    fade: fade
  });
  var initialKeyFrames = getSlideKeyFrames(_objectSpread(_objectSpread({}, defaultKeyFrameOptions), firstAnimation || {}));
  return /*#__PURE__*/React.createElement(Reveal, {
    content: content,
    className: finalClassName,
    duration: duration,
    delay: delay,
    disableAnimation: disableAnimation,
    disableAnimationOnMobile: disableAnimationOnMobile,
    cascade: cascade,
    cascadeFactor: cascadeFactor,
    triggerOnce: triggerOnce,
    onVisibilityChange: onVisibilityChange,
    keyFrames: slideKeyFrames,
    initialKeyFrames: initialKeyFrames,
    fraction: fraction,
    noContainer: noContainer
  }, children);
}
SlideReveal.defaultProps = defaultProps;